import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { Spinner } from "../components/Loading";
import { request } from "../lib/api";

function recoveryToken() {
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(window.location.search);
  return hash.get("access_token") || query.get("access_token") || query.get("token") || "";
}

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const token = useMemo(recoveryToken, []);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError("");
    if (!token) {
      setError("This password reset link is invalid or expired.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await request("/api/auth/reset-password", {
        method: "POST",
        body: JSON.stringify({ access_token: token, password })
      });
      history.replaceState(null, "", "/reset-password");
      navigate("/login", {
        replace: true,
        state: { notice: "Your password has been updated. You can sign in now." }
      });
    } catch (submissionError) {
      setError(submissionError instanceof Error ? submissionError.message : "Password reset failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout subtitle="Choose a new password">
      <h2>Set new password</h2>
      {!token ? (
        <div className="alert alert-error">
          This reset link has no recovery session. Request a new link below.
        </div>
      ) : null}
      {error ? <div className="alert alert-error">{error}</div> : null}
      <form className="form-stack" onSubmit={submit}>
        <div className="field">
          <label htmlFor="newPassword">New password</label>
          <input
            id="newPassword"
            className="input-field"
            type="password"
            minLength={8}
            autoComplete="new-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </div>
        <div className="field">
          <label htmlFor="confirmNewPassword">Confirm new password</label>
          <input
            id="confirmNewPassword"
            className="input-field"
            type="password"
            minLength={8}
            autoComplete="new-password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary btn-block" disabled={loading || !token}>
          {loading ? <Spinner small /> : null}
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
      <p className="auth-switch">
        <Link to="/forgot-password" className="text-link">
          Request another reset link
        </Link>
      </p>
    </AuthLayout>
  );
}
